import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChangeVariant = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16 13V10M16 13H19M16 13V16M16 13H13",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.3393 9.33929L8.5 8L8.6607 9.33929L10 9.5L8.6607 9.66071L8.5 11L8.3393 9.66071L7 9.5L8.3393 9.33929Z",
		fill: "currentColor",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinejoin: "round"
	})]
});
export default SvgChangeVariant;
